import { Component, OnInit } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../../../constants/constant.content'
import { NUMBER_ZERO } from '../../../../constants/constant.numbers'
import { ObservableService } from '../../../services/observable-service/observable.service'
import { AssetClassModel } from '../../../shared/asset-class-model'
import { FilterModel } from '../../../shared/filter-model'

@Component({
  selector: 'product-type-filter',
  templateUrl: './product-type-filter.component.html',
  styleUrls: ['./product-type-filter.component.scss'],
})
export class ProductTypeFilterComponent implements OnInit {
  viewProducts = ''
  isAllProductSelected = false
  filter: any
  filterBySelectedObject = { id: '', isSelected: false }
  fd3ContentFiltersListResponse: any
  constructor(
    private observableService: ObservableService,
    private filterModel: FilterModel,
  ) {}
  ngOnInit() {
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    this.fd3ContentFiltersListResponse =
      parsedCaasJson.data.fd3filtersList.items[0]
    this.filterModel.telecastProductType.subscribe((data) => {
      this.filter = data
      this.isAllProductSelected = this.isAnyProductTypeSelected()
    })
    this.observableService.filterBySelectedItemValue.subscribe((args) => {
      this.filterBySelectedObject.id = args['inputId']
      this.filterBySelectedObject.isSelected = args['isSelected']
    })
  }
  onViewProductsChange(event: any) {
    // reset the sub asset selection count to 0
    this.filterModel.setSubAssetSelectedCount(NUMBER_ZERO)
    this.viewProducts = event.radioGroupState.inputValue
    for (const key in this.filter.productType) {
      this.filter.productType[key].value = event.radioGroupState.inputId == key
    }
    this.filter.isProductTypeClicked = event.hasSelection
    if (
      this.filterBySelectedObject.id !== '' &&
      this.filterBySelectedObject.id !== undefined
    ) {
      this.verifyAssetClassSelected()
    }
    this.filterModel.editDataProductType(this.filter)
    this.observableService.viewProductClick(this.viewProducts)
  }
  verifyAssetClassSelected() {
    let filterByDefault = new AssetClassModel()
    filterByDefault.filterByLevel1[this.filterBySelectedObject.id].value =
      this.filterBySelectedObject.isSelected
    filterByDefault.isFilterByLevel1Clicked = true
    if (
      this.filter.productType.colTrust.value &&
      filterByDefault.filterByLevel1.cashEquivalent.value
    ) {
      filterByDefault =
        this.filterModel.checkCollectiveTrustWithCashEquivalentScenario(
          filterByDefault.assetCaas.trusts,
          filterByDefault,
        )
    }
    if (this.filter.productType.etf.value) {
      filterByDefault.filterByLevel1[this.filterBySelectedObject.id].value =
        false
    }
    this.filterModel.editDataFilterBy(filterByDefault)
  }

  isAnyProductTypeSelected() {
    return (
      this.filter.productType.mf.value ||
      this.filter.productType.etf.value ||
      this.filter.productType.colTrust.value
    )
  }
}
